export default "__VITE_ASSET__DOjgSLjk__"